const footerAf = {
  company: 'ګرامین بازار',
  description: 'د بنګله دېش ترټولو لوی آنلاین بازار. هر ورځ هغه څه ومومئ چې تاسو یې اړتیا لرئ.',
  links: {
    company: 'شرکت',
    business: 'سوداګري',
    support: 'ملاتړ',
    about: 'زموږ په اړه',
    career: 'مسلک',
    contact: 'اړیکه',
    help: 'مرسته',
    becomeSeller: 'پلورونکی شئ',
    businessAccount: 'د سوداګرۍ حساب',
    marketplacePolicy: 'د بازار پالیسي',
    deliveryPolicy: 'د تحویل پالیسي',
    returnPolicy: 'د بیرته ورګرځولو پالیسي',
    privacyPolicy: 'د خصوصیت پالیسي',
  },
  contact: {
    heading: 'اړیکه',
    address: 'کور #123، لار #45، بناني، ډاکا-1213',
  },
  copyright: (year) => `© ${year} ګرامین بازار. ټول حقونه ساتل شوي.`,
};

export default footerAf;
